// useAnalytics — emits a page_view on every route change, returns track()
// for explicit events. Consumers in components: `const { track } = useAnalytics()`.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { track, trackPageView } from '@core/services/analyticsService';

export function useAnalytics() {
  return { track };
}

export function useRoutePageviews() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    trackPageView(pathname + search);
  }, [pathname, search]);
}
